import styles from './Status.module.css'
import { Spinner } from '@fluentui/react-components'

const LoadingSpinner = ({ text }: { text?: string }) => (
  <div data-testid="LoadingSpinner">
    <p className={styles.loadingSpinner}>{text ?? 'Laddas...'}</p>
    <Spinner size="small" />
  </div>
)

export default LoadingSpinner
